module.exports = __webpack_public_path__ + "img/project6_3.png.d34bd9c5.webp";